const Profiile = () => (
    <>
        Profiile
    </>
);

export default Profiile;
